// Get all the keys from document
var keys = document.querySelectorAll('.keys span');
var input = document.querySelector('#quantity');
var xPounds = document.querySelector('#xPounds');
var poundsCount = document.querySelector('#poundsCount');
var screen = document.querySelector('#quantity');
var pound = 453.59237;//grams
var isFirst = true;
var previous = "";

function unlightAll(){
	for(var c = 0; c < keys.length; c++) {
    	if(keys[c].innerHTML != 'C'){
			keys[c].className = "key not-pressed";
    	}
	}
}

function clear(){
	isFirst = true;
	xPounds.value = 0;
	poundsCount.innerHTML = "";
	unlightAll();
}

input.onkeydown = function() {
	previous = screen.value;
}
input.onchange = function() {
	clear();
}

input.onkeyup = function() {
	if(screen.value != previous){
		clear();
		unlightAll();
	}
}

//minimum quantity validation (it's a hack, but the existing code is a mess)
input.onchange = function() {
  if (input.value < 114 && input.value > 0) {
    alert ('Minimum purchase: 1/4 lbs (114 g)');
    input.value = 114; 
  }
}


// Add onclick event to all the keys and update quantity
for(var i = 0; i < keys.length; i++) {
	keys[i].onclick = function(e) {
		unlightAll();
		var operator = this.innerHTML;
      	if(operator != 'C'){
			if(isFirst){
				isFirst = false;
				this.className = "key pressed";
			}
			if(screen.value == '1'){
				screen.value = 0;
			}
			switch(operator){
				case "5 lb":
					xPounds.value = parseFloat(xPounds.value) + 5;
					break;
				case "1 lb":
					xPounds.value = parseFloat(xPounds.value) + 1;
					break;
				case "1/2 lb":
					xPounds.value = parseFloat(xPounds.value) + 0.5;
					break;
				case "1/4 lb":
					xPounds.value = parseFloat(xPounds.value) + 0.25;
					break;
				default:
					screen.value += operator;
			}
			poundsCount.innerHTML = "(" + xPounds.value + " pounds)";
			screen.value = Math.ceil(pound * parseFloat(xPounds.value));
        }
      	else{
        	clear();
          	screen.value = 1;
      	}
	}
}